import React from 'react';
import { connect } from 'react-redux';
import {
  Layout, Row, Col, Divider,
} from 'antd';

import config from '../config';

import Analytics from '../helpers/Analytics';
import colors from '../constants/Colors';
import AppMenu from './AppMenu';
import NuxModal from '../nux/NuxModal';
import Logout from '../auth/logout';
import Logo from '../common/Logo';

import DivisionsDropdown from './DivisionsDropdown';
import Version from './Version';

import { setOpenKeys, setMenu } from './state/menu.actions';
import { createNuxEntry, startNuxAction } from '../nux/state/nux.actions';
import { acceptToS } from '../users/state/users.actions';

import { getOpenKeys, formatMenuItem } from './menu.helpers';

import NuxFocusBackground from '../nux/NuxFocusBackground';

import { getTutorials } from '../learningCenter/state/learningCenter.actions';

import {
  GET_START_CLOSE_TYPE,
  GET_STARTED_CLOSE_NUX_STEP_1,
  NEW_MENU_TYPE,
  NEW_MENU_NUX_STEP_1,
} from '../nux/nux.constants';
import LearningCenterDrawer from '../learningCenter/LearningCenterDrawer';
import sidebarLogo from '../assets/images/ontraccr-sidebar-logo.png';

const {
  Sider,
} = Layout;

export default connect(
  (state,ownProps) => {
    return {
      ...ownProps,
      selectedKeys:state.menu.items,
      openKeys:state.menu.openKeys,
      approvalCount:state.approvals.approvalCount,
      nux:state.nux.nux,
      activeNuxAction:state.nux.activeNuxAction,
      nuxLoaded:state.nux.nuxLoaded,
      tutorials:state.learningCenter.tutorials,
      company: state.settings.company,
      isMenuOpen: state.menu.isMenuOpen,
    };
  },{
    setMenu,
    setOpenKeys,
    createNuxEntry,
    acceptToS,
    startNuxAction,
    getTutorials,
  }
)(class Menu extends React.Component {
  constructor(props){
    super(props);
    this.state = {
      selectedKeys:[],
      openKeys:[],
    };
    this.onMenuPicked = this.menuPicked.bind(this);
    this.onOpenChange = this.openChanged.bind(this);
    this.onGetStartedClose = this.getStartedClose.bind(this);
    this.onLearningCenterClose = this.learningCenterClose.bind(this);
    this.sawGetStartedNux = false;
    this.props.getTutorials();
  }

  componentDidMount() {
    const {
      pathname,
      setMenu,
      setOpenKeys,
    } = this.props;
    try {
      const firstLogin = window.sessionStorage.getItem('firstLogin');
      const acceptedTos = window.sessionStorage.getItem('acceptedToS') === '1';

      if(firstLogin === 'true' || !acceptedTos) {
        this.props.setMenu(['getStarted']);
        this.sawGetStartedNux = true;
        return;
      }
    } catch(err) {
      console.log('Failed loading first login screen');
    }

    const menuItem = formatMenuItem(pathname);

    setMenu([menuItem]);
    const newOpen = getOpenKeys(menuItem);
    setOpenKeys(newOpen);
  }

  componentDidUpdate(prevProps) {
    const {
      pathname,
      setMenu,
      nux,
      createNuxEntry,
      startNuxAction,
    } = this.props;
    const {
      pathname:prevPath,
    } = prevProps;

    if(pathname !== prevPath){
      const menuItem = formatMenuItem(pathname);
      setMenu([menuItem]);
    }

    try {
      const { newMenuTimestamp } = config;
      const firstLogin = window.sessionStorage.getItem('firstLogin');
      const lastActive = window.sessionStorage.getItem('lastActive');

      if(
        firstLogin !== 'true'
        && parseInt(lastActive,10) < parseInt(newMenuTimestamp, 10)
        && nux.size > 0
        && !nux.has(NEW_MENU_TYPE)
      ) {
        // Show new menu
        createNuxEntry(NEW_MENU_TYPE);
        startNuxAction(NEW_MENU_NUX_STEP_1);
      }
    } catch(err) {
      console.log('Failed loading first login screen');
    }
  }

  menuPicked(e) {
    const {
      selectedKeys = [],
    } = this.props;
    Analytics.track('PageSelect',{ key: e.key });
    switch(e.key) {
      case 'logout':
        Logout(this.props.onLogout);
        break;
      case 'support':
      case 'feedback':
      case 'profile':
      case 'getStarted':
        if(e.key === 'getStarted') {
          Analytics.track('NUX/Open',{ Source: 'Menu' });
        }
        this.props.setMenu(selectedKeys.concat([e.key,]));
        break;
      // Submenus
      case 'documents':
      case 'scheduling':
      case 'timecards':
      case 'staff':
      case 'contacts':
      case 'projects-parent':
      case 'costcodes':
      case 'reports-parent':
      case 'tasks':
        break;
      default:
        this.props.setMenu([e.key]);
        this.props.onMenuPicked(e);
    }
  }

  removeMenuSelect(invalid) {
    const {
      selectedKeys = [],
      setMenu,
    } = this.props;
    setMenu(selectedKeys.filter(key => key !== invalid))
  }

  openChanged(open) {
    this.props.setOpenKeys(open.filter((key) => !this.state.openKeys.includes(key)));
  }

  supportCloseClicked() {
    const {
      selectedKeys = [],
      setMenu,
    } = this.props;
    setMenu(selectedKeys.filter(key => key !== 'support'))
  }

  supportClosed() {
  }

  feedbackClosed() {

  }

  feedbackCloseClicked() {
    this.removeMenuSelect('feedback');
  }

  profileClosedClicked() {
    this.removeMenuSelect('profile');
  }

  getStartedClose() {
    const {
      nux = new Set(),
      startNuxAction,
      createNuxEntry,
    } = this.props;
    this.removeMenuSelect('getStarted');
    if(!nux.has(GET_START_CLOSE_TYPE)) {
      startNuxAction(GET_STARTED_CLOSE_NUX_STEP_1);
      createNuxEntry(GET_START_CLOSE_TYPE);
    }
  }

  learningCenterClose() {
    this.removeMenuSelect('learningCenter');
  }

  render() {
    const {
      selectedKeys = [],
      openKeys = [],
      fullscreen,
      approvalCount,
      history,
      nux = new Set(),
      createNuxEntry,
      acceptToS,
      activeNuxAction,
      company,
      isMenuOpen,
    } = this.props;

    const hasRedesign = company?.settings?.uxRedesignPt1;
    let menuWidth = hasRedesign ? 220 : 200;
    if (!isMenuOpen) {
      menuWidth = 80;
    }

    const logoStyle = hasRedesign ? {
      display: 'flex',
      verticalAlign: 'middle',
      alignItems: 'center',
    } : {};

    return (
      <Sider
        collapsed={fullscreen}
        collapsedWidth={0}
        width={menuWidth}
        style={{
          minHeight: '100vh',
          backgroundColor: hasRedesign ? colors.REDESIGN_PRIMARY_TEXT : colors.ONTRACCR_BLACK,
          height: '100vh',
          position: 'fixed',
          left: 0,
          width: menuWidth,
          transition: 'all 1s',
        }}
      >
        <NuxFocusBackground show={activeNuxAction}/>
          <Row
            type='flex'
            justify={hasRedesign && isMenuOpen ? 'flex-start' : 'center'}
            style={{
              marginTop:hasRedesign ? 5 : 19,
              width:'100%',
              marginBottom:hasRedesign ? 5 : 22,
              marginLeft: hasRedesign && isMenuOpen ? 16 : 0,
              height: hasRedesign ? 65 : 'auto',
            }}
          >
            <Col style={logoStyle}>
              { isMenuOpen && (
                  <Logo
                    darkMode
                    height={hasRedesign ? 34 : 55}
                    style={{ padding: 3 }}
                  />
              )}
              { !isMenuOpen && (
                <img
                  src={sidebarLogo}
                  alt="Ontraccr Logo"
                  style={{
                    width: 23,
                    height: 36,
                  }}
                />
              )}
            </Col>
          </Row>
          <Row
            type='flex'
            justify='center'
            style={{
              paddingLeft:hasRedesign ? 0 : 15,
              paddingRight:hasRedesign ? 0 : 15,
            }}
          >
            { isMenuOpen && (<DivisionsDropdown/> )}
            <Divider style={{
              backgroundColor: hasRedesign
                ? colors.REDESIGN_BUTTON_UNSELECTED_TEXT
                : colors.opacity(colors.LIGHT_GRAY,0.4),
              height:1,
              margin:0,
            }}/>
          </Row>
          <div id='app-menu-scroll'>
            <div id='app-menu-container'>
            <AppMenu
              className='Menu'
              onMenuPicked={this.onMenuPicked}
              onOpenChange={this.onOpenChange}
              selectedKeys={selectedKeys}
              openKeys={openKeys}
              approvalCount={approvalCount}
              nux={nux}
              activeNuxAction={activeNuxAction}
              createNuxEntry={createNuxEntry}
            />
            </div>
            <Version/>
          </div>
          <LearningCenterDrawer
            visible={selectedKeys.indexOf('learningCenter') >= 0}
            onClose={this.onLearningCenterClose}
            tutorials={this.props.tutorials}
            nux={nux}
          />
          <NuxModal
            nux={nux}
            visible={selectedKeys.indexOf('getStarted') >= 0}
            onCloseClicked={this.onGetStartedClose}
            history={history}
            createNuxEntry={createNuxEntry}
            acceptToS={acceptToS}
          />
      </Sider>
    );
  }
});
